const pages = {
  WELCOME_PATH: 'welcome',
  WELCOME_VIEW: 'Welcome',
  INSTRUCTIONS_PATH: 'instructions',
  INSTRUCTIONS_VIEW: 'Instructions',
  MAIN_PATH: '/',
  MAIN_VIEW: 'Main',
  QUESTIONS_PATH: 'questions',
  QUESTIONS_VIEW: 'Questions',
  SOLVE_PATH: 'solve',
  SOLVE_VIEW: 'Solve',
  ABOUT_PATH: 'about',
  ABOUT_VIEW: 'About',
  GAME_OVER_PATH: 'gameover',
  GAME_OVER_VIEW: 'GameOver'
}

export default pages
